module.exports = __webpack_public_path__ + "img/luxuryyacht_thumb_02.0ad31523.jpg";